/**
 * gets boolean value to determine if an entry is valid
 * @param  {Object} entry
 * @return {boolean}
 */
export const isEntryValid = (entry) => {
  if (!entry || typeof entry !== 'object') return false;
  return (
    Object.prototype.hasOwnProperty.call(entry, 'endDate') &&
    entry.endDate !== null &&
    Object.prototype.hasOwnProperty.call(entry, 'runOnDate') &&
    entry.runOnDate !== null &&
    Object.prototype.hasOwnProperty.call(entry, 'startDate') &&
    entry.startDate !== null &&
    Object.prototype.hasOwnProperty.call(entry, 'name') &&
    entry.name?.trim() !== ''
  );
};
